import React, { Component } from 'react';
import ProjectEntry from './projectEntry';
import { Constants } from "../constants";
import '../css/stuff.css';

// Deploy new project sequence:
// https://console.firebase.google.com/u/0/


class TheRestInMotionSite extends Component {
    componentDidMount() {
        // Initialize theme from localStorage or system preference
        const saved = localStorage.getItem('theme');
        const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        const theme = saved || (prefersDark ? 'dark' : 'light');
        document.documentElement.setAttribute('data-theme', theme);
    }

    toggleTheme = () => {
        const current = document.documentElement.getAttribute('data-theme') || 'light';
        const next = current === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        localStorage.setItem('theme', next);
        this.forceUpdate();
    }

    render() {
        const theme = document.documentElement.getAttribute('data-theme') || 'light';
        return (
            <div className={'site-wrapper'}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h1>The Rest In Motion</h1>
                    <div>
                        <button onClick={this.toggleTheme} aria-pressed={theme === 'dark'} className={'theme-toggle'}>
                            {theme === 'dark' ? 'Switch to light' : 'Switch to dark'}
                        </button>
                    </div>
                </div>
                <ul>
                    <li>
                        <ProjectEntry
                            name={'DUKX'}
                            link={'https://dukx.app'}
                            date={'February 2021'}
                            description={'A puzzle game with a novel clean logical structure. Initially conceived in ' +
                                '2017, it took a while to develop and flesh out the idea.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'Optimistic Minesweeper'}
                            link={'https://minesweeper.therestinmotion.com'}
                            codelink={'https://github.com/kord/optimistic-minesweeper'}
                            date={'May 2021'}
                            description={'A variant of minesweeper where if your situation really demands that you ' +
                                'guess, the minefield gets rewritten to a consistent state where your guess succeeds. ' +
                                'Also, as essential intermediate work, a minesweeper that plays itself, like a ' +
                                'screensaver. 43% success rate on classic expert mode, not quite the state of the art.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'Soundcheck'}
                            link={'https://soundcheck.therestinmotion.com'}
                            wip={true}
                            date={'June 2021'}
                            description={'Incomplete demo, attempting to develop visualizations of microphone ' +
                                'pitch changes.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'Kuromasu'}
                            link={'https://kuromasu.therestinmotion.com'}
                            date={'July 2021'}
                            description={'Kuromasu puzzle. Essentially a clone of 0h n0, but with a SAT solver ' +
                                'hooked up.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'Light Up'}
                            link={'https://lightup.therestinmotion.com'}
                            date={'July 2021'}
                            description={'Light Up puzzle. Another classic Nikoli puzzle.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'Wordle'}
                            link={'https://wordle.therestinmotion.com'}
                            codelink={'https://github.com/kord/wordle-clone'}
                            date={'January 2022'}
                            description={'Clone of the viral Word puzzle Wordle. Word lengths of 4-7 provided.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'Floaters'}
                            wip={false}
                            link={'https://floaters.therestinmotion.com'}
                            date={'February 2022'}
                            description={'Making some inert dots accelerate strategically to form nice ' +
                                'patterns. Deprecated by Floaters v2, below.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'Dungeons and Diagrams'}
                            wip={false}
                            link={'https://dandd.therestinmotion.com'}
                            codelink={'https://github.com/kord/DungeonsAndDiagrams'}
                            date={'January 2023'}
                            description={'Reproduction of a puzzle scheme originated by Zachtronics. ' +
                                'Really needs a mouse to work well.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'Word Matcher'}
                            wip={false}
                            link={'https://wordmatcher.therestinmotion.com'}
                            codelink={'https://github.com/kord/wordmatcher'}
                            date={'December 2023'}
                            description={'Simple game for learning Chinese. Options are provided for learning HSK' +
                                ' word lists, most common words, differences between simplified and traditional ' +
                                'characters, with more to come. Deprecated by Word Matcher v2, below.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'There\'s No Place Like Home'}
                            link={'https://vimeo.com/1003704232'}
                            date={'August 2024'}
                            description={'Short film.'}
                            duration={'25:36'}
                        />
                    </li>

                    <li>
                        <ProjectEntry
                            name={'Scrabble Helper'}
                            link={'https://scrabble.therestinmotion.com'}
                            codelink={'https://github.com/kord/scrabble-lookup'}
                            date={'May 2026'}
                            description={'Easily check the prefixes and suffixes for a given word and find ' +
                                'anagrams of a rack, with support for blanks. Support for multiple dictionaries.'}

                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'Multitimer'}
                            wip={true}
                            link={'https://multitimer.therestinmotion.com'}
                            codelink={'https://github.com/kord/multitimer'}
                            date={'June 2026'}
                            description={'Set up a multitude of persistent timers for various purposes, with a simple interface and persistance through localstorage.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'World Cup 2026 Bracket Comparer'}
                            wip={false}
                            link={'https://worldcup2026.therestinmotion.com'}
                            codelink={'https://github.com/kord/world-cup-2026-bracket'}
                            date={'June 2026'}
                            additionalLink={{ text: 'My picks', url: 'https://worldcup2026.therestinmotion.com/?add=UwdTRlfE-ELKvyTG-GXwXjsX1ykSNRrJqLzNtBP_EA' }}
                            description={'Share and compare brackets for the 2026 World Cup with a simple interface.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'Train Tracks Puzzle'}
                            wip={false}
                            codelink={'https://github.com/kord/trains-puzzle'}
                            link={'https://traintracks.therestinmotion.com'}
                            date={'August 2026'}
                            description={'Another classic Nikoli puzzle. Construct a valid train track configuration given a set of constraints. Daily puzzles.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'Yin Yang Puzzle'}
                            wip={true}
                            codelink={'https://github.com/kord/yin-yang-puzzle'}
                            link={'https://yinyang.therestinmotion.com'}
                            date={'September 2026'}
                            description={'Nice fun simple puzzle set on a Go board. Daily puzzles.'}

                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'Word Matcher v2'}
                            wip={true}
                            codelink={'https://github.com/kord/wordmatcher-v2'}
                            link={'https://wordmatcherv2.therestinmotion.com'}
                            date={'September 2026'}
                            description={'Simple game for learning Chinese. Written from scratch adapting ' +
                                'v1 assisted by Deepseek V4.1 in one night. They\'re coming for ' +
                                'ya. The machines are gonna get ya. Options are provided for learning HSK ' +
                                'word lists, most common words, differences between simplified and ' +
                                'traditional characters. PWA for installation and use on handheld devices.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'Floaters v2'}
                            wip={true}
                            link={'https://floatersv2.therestinmotion.com'}
                            date={'September 2026'}
                            description={'Inspired by drone light shows, this is a more sophisticated version of the ' +
                                'original Floaters. Now in 3D, with more demonstrations. Turn on trails or Velocity ' +
                                'vectors and watch point masses efficiently transition to different configurations, ' +
                                'including recalculation from any intermediate position. Not sure what to do with this.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'LITS'}
                            wip={true}
                            link={'https://lits.therestinmotion.com'}
                            date={'September 2026'}
                            description={'Yet another Nikoli puzzle. Fill in tetrominoes in a grid with some constraints. Daily puzzles.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'Slitherlinks'}
                            wip={true}
                            link={'https://slitherlinks.therestinmotion.com'}
                            date={'September 2026'}
                            description={'Really into puzzles lately. Another Nikoli puzzle. Draw a ' +
                                'single loop through a grid with some constraints. Daily puzzles. ' +
                                'Assistance mode to reduce a bit of the drudgery if you so desire.'}
                        />
                    </li>
                    <li>
                        <ProjectEntry
                            name={'Nonograms'}
                            wip={true}
                            link={'https://nonograms.therestinmotion.com'}
                            date={'October 2026'}
                            description={'Curated batch of nonograms in a variety of sizes. Very pleased with the success animation.'}
                        />
                    </li>

                </ul>

                <div className={'footer'}>
                    I can be contacted at
                    <a href={Constants.emailUrl} className={'email-link'}>
                        TheRestInMotion@gmail.com
                    </a>.
                </div>
            </div>
        );
    }
}

export default TheRestInMotionSite;